import { xMaxValue } from 'ml-spectra-processing/x';
import { seriesFromArray } from "../series_from_array.js";
export function percentageFilter(chromatogram, seriesName, options = {}) {
    const { percentage = 0.1 } = options;
    const series = chromatogram.getSeries2D(seriesName);
    const filtered = [];
    const data = series.getData();
    for (const item of data) {
        filtered.push(applyFilter(item, percentage));
    }
    return seriesFromArray(filtered);
}
function applyFilter(series, percentage) {
    let basePeak;
    try {
        basePeak = xMaxValue(series[1]);
    }
    catch {
        basePeak = 0;
    }
    const filtered = [[], []];
    for (let i = 0; i < series[0].length; i++) {
        if (series[1][i] > percentage * basePeak) {
            filtered[0].push(series[0][i]);
            filtered[1].push(series[1][i]);
        }
    }
    return filtered;
}
//# sourceMappingURL=percentage_filter.js.map